import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import type {
  APIResponse,
  LawWorksCharge,
  LawWorksChargeQuery,
} from "@/lib/types";

export const retrieveMatterLawWorksCharges = ({
  matterId,
  ...params
}: LawWorksChargeQuery & { matterId: string }) =>
  authenticatedFastApiAxiosInstance
    .get<
      APIResponse<LawWorksCharge[]>
    >(`${baseFastApiMatterRoute}/${matterId}/charges`, { params })
    .then((res) => res.data);
